// ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthService } from "../Services/AuthService";
import { SubscriptionProvider } from "./SubscriptionContext";
import { useAuth } from "./AuthContext"

const ProtectedRoute = ({ children }) => {

  const { isAuthenticated} = useAuth();

  return isAuthenticated ? <SubscriptionProvider><Outlet /></SubscriptionProvider> : <Navigate to="/login" replace />;

};

export default ProtectedRoute;
